export enum StrikelogConflictStatus {
  ongoing = 'ONGOING',
  draft = 'DRAFT',
  ended = 'ENDED',
  initializing = 'INITIALIZING'
}
